import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../components/Layout.vue';
import Payment from '../views/Payment.vue';
import EmbedPayment from '../views/EmbedPayment.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'index',
          component: Payment,
        },
      ],
    },
    {
      path: '/embed',
      name: 'embed',
      component: EmbedPayment,
    },
  ],
});
